<template>
    <v-row>
        <v-col cols="12">
            <vuetify-table
                :headers="headers"
                :api-u-r-l="apiURL"
                :title="title"
                :back="true"
                back-u-r-l="documentos"
            >
            </vuetify-table>
        </v-col>
    </v-row>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('documents') };
    },
    components: {
        VuetifyTable,
    },
    props: {
      enterprise_id: { default: '' },
      serie: { default: '' },
      type: { default: '' },
      number: { default: '' },
    },
    data: () => ({
      headers: [
        {
          text: 'Teléfono',
          value: 'number',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'estado',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Fecha  ',
          value: 'created_at',
          align: 'left',
          sortable: true,
        },
      ],
    }),
    computed: {
        apiURL() {
          return `/api/documents/tracking-sms/${this.enterprise_id}/${this.serie}/${this.type}/${this.number}`;
        },
        title() {
          return `Historial de SMS | Documento: <b>${this.number}</b>`;
        },
    },
};
</script>
